<template>
    <div class="donate-form-page layout-sub-page">
        <!-- 0、返回按钮 -->
        <div class="donate-btn-back" @click="clickBack">
            <i class="iconfont icon-xiangzuo"></i>返回
        </div>
        <!-- 1、捐赠编辑部分 -->
        <donate-edit-form v-if="!donateSuccess"></donate-edit-form>

        <!-- 2、捐赠结果及分享部分 -->
        <donate-result-share v-else></donate-result-share>
    </div>
</template>

<script>
import * as doctitle from '../../modules/data/base/doctitle'
import DonateEditForm from '../../layouts/donate/DonateEditForm.vue'
import DonateResultShare from '../../layouts/donate/DonateResultShare.vue'
import { DOM } from '../../modules/dom';
export default {
    name: 'DonateForm',
    components: { DonateEditForm, DonateResultShare },
    computed: {
        donateSuccess() {
            return this.$store.state.donate.donateSuccess;
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
            window.scrollTo(0, 0);
        }, 20);
        setTimeout(() => {
            DOM.setStopTouch();
        }, 100);
    },
    methods: {
        initDom() {
            this.$el.style.width = innerWidth + 'px';
            this.$el.style.height = innerHeight + 'px';
            this.$el.style.overflow = 'hidden';
            var me = this;
            window.onresize = function() {
                me.$el.style.width = innerWidth + 'px';
                me.$el.style.height = innerHeight + 'px';
                me.$el.style.overflow = 'hidden';
            }
        },
        clickBack() {
            DOM.resetStopTouch();
            DOM.showParentPageByClassName('donate-page');
            this.$router.replace('/donate');
            // 重置状态
            this.$store.state.donate.donateSuccess = false;
            setTimeout(() => {
                DOM.setDocumentTitle(doctitle.TITLE_DONATE);
            }, 20);
        }
    }
}
</script>